
declare global {

    var dataLayer: any[];
    function gtag(...args: unknown[]): void;
}

class Analytics {
    constructor() {


    }

    init(tagName: string) {

        window.dataLayer = window.dataLayer || [];
        window.gtag = function () {
            window.dataLayer.push(arguments);
        };

        gtag('js', new Date());
        gtag('config', tagName);

        const script = document.createElement("script");
        script.src = "https://www.googletagmanager.com/gtag/js?id=" + tagName;
        document.head.appendChild(script);
    }

    pageView() {

        gtag('event', 'page_view', {
            page_title: document.title,
            page_path: window.location.pathname
        });
    }
}



export const analytics = new Analytics();